import { defaultApiState } from '../api.state';

export const userManagementMutations = {
  GET_ADMINS_LOADING(state) {
    state.apiState.getAdmins = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_ADMINS_SUCCESS(state, payload) {
    state.apiState.getAdmins = {
      ...defaultApiState,
      success: true,
    };
    state.admins = payload;
  },
  GET_ADMINS_ERROR(state, error) {
    state.apiState.getAdmins = {
      ...defaultApiState,
      error,
    };
  },

  GET_ADMIN_LOADING(state) {
    state.apiState.getAdmin = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_ADMIN_SUCCESS(state, payload) {
    state.apiState.getAdmin = {
      ...defaultApiState,
      success: true,
    };
    state.admin = payload;
  },
  GET_ADMIN_ERROR(state, error) {
    state.apiState.getAdmin = {
      ...defaultApiState,
      error,
    };
  },

  ADD_ADMIN_LOADING(state) {
    state.apiState.addAdmin = {
      ...defaultApiState,
      loading: true,
    };
  },
  ADD_ADMIN_SUCCESS(state) {
    state.apiState.addAdmin = {
      ...defaultApiState,
      success: true,
    };
  },
  ADD_ADMIN_ERROR(state, error) {
    state.apiState.addAdmin = {
      ...defaultApiState,
      error,
    };
  },

  UPDATE_ADMIN_LOADING(state) {
    state.apiState.updateAdmin = {
      ...defaultApiState,
      loading: true,
    };
  },
  UPDATE_ADMIN_SUCCESS(state) {
    state.apiState.updateAdmin = {
      ...defaultApiState,
      success: true,
    };
  },
  UPDATE_ADMIN_ERROR(state, error) {
    state.apiState.updateAdmin = {
      ...defaultApiState,
      error,
    };
  },

  DELETE_ADMIN_LOADING(state) {
    state.apiState.deleteAdmin = {
      ...defaultApiState,
      loading: true,
    };
  },
  DELETE_ADMIN_SUCCESS(state, payload) {
    state.apiState.deleteAdmin = {
      ...defaultApiState,
      success: true,
    };
    state.admins = state.admins.filter(o => o.id !== payload.id);
  },
  DELETE_ADMIN_ERROR(state, error) {
    state.apiState.deleteAdmin = {
      ...defaultApiState,
      error,
    };
  },
  UPDATE_ADMIN_PASSWORD_LOADING(state) {
    state.apiState.updateAdminPassword = {
      ...defaultApiState,
      loading: true,
    };
  },
  UPDATE_ADMIN_PASSWORD_SUCCESS(state) {
    state.apiState.updateAdminPassword = {
      ...defaultApiState,
      success: true,
    };
  },
  UPDATE_ADMIN_PASSWORD_ERROR(state, error) {
    state.apiState.updateAdminPassword = {
      ...defaultApiState,
      error,
    };
  },

  GET_USERS_LOADING(state) {
    state.apiState.getUsers = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_USERS_SUCCESS(state, payload) {
    state.apiState.getUsers = {
      ...defaultApiState,
      success: true,
    };
    state.users = payload;
  },
  GET_USERS_ERROR(state, error) {
    state.apiState.getUsers = {
      ...defaultApiState,
      error,
    };
  },
  GET_USER_LOADING(state) {
    state.apiState.getUser = {
      ...defaultApiState,
      loading: true,
    };
    state.user = undefined;
    state.transactions = [];
  },
  GET_USER_SUCCESS(state, payload) {
    state.apiState.getUser = {
      ...defaultApiState,
      success: true,
    };
    state.user = payload;
  },
  GET_USER_ERROR(state, error) {
    state.apiState.getUser = {
      ...defaultApiState,
      error,
    };
  },
  UPDATE_USER_LOADING(state) {
    state.apiState.updateUser = {
      ...defaultApiState,
      loading: true,
    };
  },
  UPDATE_USER_SUCCESS(state) {
    state.apiState.updateUser = {
      ...defaultApiState,
      success: true,
    };
  },
  UPDATE_USER_ERROR(state, error) {
    state.apiState.updateUser = {
      ...defaultApiState,
      error,
    };
  },

  GET_USER_TRANSACTIONS_LOADING(state) {
    state.apiState.getUserTransactions = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_USER_TRANSACTIONS_SUCCESS(state, payload) {
    state.apiState.getUserTransactions = {
      ...defaultApiState,
      success: true,
    };
    state.transactions = payload;
  },
  GET_USER_TRANSACTIONS_ERROR(state, error) {
    state.apiState.getUserTransactions = {
      ...defaultApiState,
      error,
    };
  },

  GET_USER_SUBSCRIPTIONS_LOADING(state) {
    state.apiState.getUserSubscriptions = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_USER_SUBSCRIPTIONS_SUCCESS(state, payload) {
    state.apiState.getUserSubscriptions = {
      ...defaultApiState,
      success: true,
    };
    state.subscriptions = payload;
  },
  GET_USER_SUBSCRIPTIONS_ERROR(state, error) {
    state.apiState.getUserSubscriptions = {
      ...defaultApiState,
      error,
    };
  },
};
